import React from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material'
import useStyles from './styles'
import { Danger as DangerIcon, InfoCircle, DocumentCopy } from '@refera/ui-icons'
import Theme from '@refera/ui-core'
import { LoadingBackdrop } from '_/components/LoadingBackdrop'

export function Root({
  children,
  isLoading,
  className = '',
  onClose,
  disableBackdropClick = false,
  ...rest
}) {
  const styles = useStyles()
  const handleClose = (event, reason) => {
    if (disableBackdropClick && reason === 'backdropClick') return
    if (rest.disableEscapeKeyDown && reason === 'escapeKeyDown') return
    if (onClose) onClose(event, reason)
  }

  return (
    <Dialog
      className={`${styles.root} ${className}`}
      aria-labelledby="customized-dialog-title"
      onClose={handleClose}
      {...rest}
    >
      <LoadingBackdrop open={isLoading} />
      {children}
    </Dialog>
  )
}

export function TitleModal({ title, children, className = '', ...rest }) {
  const styles = useStyles()

  return (
    <DialogTitle className={`${styles.dialogTitle} ${className}`.trim()} {...rest}>
      {title && <Typography className={styles.title}>{title}</Typography>}
      {children}
    </DialogTitle>
  )
}

export function Content({ children, className = '', ...rest }) {
  const styles = useStyles()

  return (
    <DialogContent className={`${styles.dialogContent} ${className}`.trim()} {...rest}>
      {children}
    </DialogContent>
  )
}

export function Actions({ children, className = '', ...rest }) {
  const styles = useStyles()

  return (
    <DialogActions className={`${styles.dialogActions} ${className}`.trim()} {...rest}>
      {children}
    </DialogActions>
  )
}

export function ButtonBlue({ children, ...rest }) {
  const styles = useStyles()

  return (
    <Button className={[styles.buttonBlue, styles.button]} {...rest}>
      {children}
    </Button>
  )
}

export function ButtonRed({ children, ...rest }) {
  const styles = useStyles()

  return (
    <Button className={[styles.buttonRed, styles.button]} {...rest}>
      {children}
    </Button>
  )
}

export function ButtonFullBlue({ children, ...rest }) {
  const styles = useStyles()

  return (
    <Button className={[styles.buttonFullBlue, styles.button]} {...rest}>
      {children}
    </Button>
  )
}

export function ButtonFullRed({ children, ...rest }) {
  const styles = useStyles()

  return (
    <Button className={[styles.buttonFullRed, styles.button]} {...rest}>
      {children}
    </Button>
  )
}

export function Text({ children, ...rest }) {
  const styles = useStyles()
  return (
    <Typography className={styles.text} {...rest}>
      {children}
    </Typography>
  )
}

export function SubTitle({ children, ...rest }) {
  const styles = useStyles()
  return (
    <Typography className={styles.subTitle} {...rest}>
      {children}
    </Typography>
  )
}

export function Title({ text, className = '', ...rest }) {
  const styles = useStyles()
  return (
    <Typography className={`${styles.title} ${className}`} {...rest}>
      {text}
    </Typography>
  )
}

export function WarningIcon({ ...rest }) {
  const styles = useStyles()
  return (
    <Grid className={styles.iconDiv}>
      <DangerIcon color={Theme.Colors.Yellow.Base} fontSize={48} {...rest} />
    </Grid>
  )
}

export function InfoIcon({ ...rest }) {
  const styles = useStyles()
  return (
    <Grid className={styles.iconDiv2}>
      <InfoCircle color={Theme.Colors.Primary.Base} fontSize={48} {...rest} />
    </Grid>
  )
}

export function DocumentCopyIcon({ ...rest }) {
  const styles = useStyles()

  return (
    <Grid className={styles.iconDiv2}>
      <DocumentCopy color={Theme.Colors.Primary.Base} fontSize={48} {...rest} />
    </Grid>
  )
}

export function InputDisabled({ text, label, ...rest }) {
  const styles = useStyles()
  return (
    <>
      <Typography className={styles.text}>
        <strong>{label}</strong>
      </Typography>
      <Grid className={styles.card}>
        <Typography className={styles.label} {...rest}>
          {text}
        </Typography>
      </Grid>
    </>
  )
}
